import { render, staticRenderFns } from "./previewLoader.vue?vue&type=template&id=6b147c5a&scoped=true&"
var script = {}
import style0 from "./previewLoader.vue?vue&type=style&index=0&id=6b147c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b147c5a",
  null
  
)

export default component.exports